import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const Countdown = ({ onFinish }) => {
    useEffect(() => {
        // Random match delay between 0.5s and 1.5s
        const delay = 500 + Math.random() * 1000;
        const timer = setTimeout(() => {
            onFinish();
        }, delay);
        return () => clearTimeout(timer);
    }, [onFinish]);

    return (
        <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'rgba(0,0,0,0.5)',
            zIndex: 100,
            pointerEvents: 'none'
        }}>
            <div style={{
                fontSize: '80px',
                fontWeight: '900',
                color: '#fff',
                letterSpacing: '5px',
                textShadow: '0 0 20px rgba(0,0,0,0.5)',
                animation: 'pulse 1.5s ease-in-out infinite'
            }}>
                STANDBY...
            </div>
            <style>{`
                @keyframes pulse {
                    0% { transform: scale(0.95); opacity: 0.7; }
                    50% { transform: scale(1.05); opacity: 1; }
                    100% { transform: scale(0.95); opacity: 0.7; }
                }
            `}</style>
        </div>
    );
};

Countdown.propTypes = {
    onFinish: PropTypes.func.isRequired
};

export default Countdown;
